"use client"

import type { UseQuickServiceProps, UseQuickServiceResult } from "@/types/types"
import { useMemo } from "react"

export const useQuickService = ({ items = [], componentId }: UseQuickServiceProps): UseQuickServiceResult => {
  const validItems = useMemo(() => {
    const filtered = items.filter(item => {
      const hasImage = !!item.image && item.image.trim().length > 0
      return hasImage
    })

    // Giới hạn tối đa 3 item
    return filtered.slice(0, 3)
  }, [items])

  const hasValidItems = validItems.length > 0

  const id = useMemo(() => componentId || `quick-service-${Math.random().toString(36).substring(2, 9)}`, [componentId])

  return {
    id,
    validItems,
    hasValidItems,
  }
}
